<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { initWebSocket, closeWebsocket } from "./util/socket";
import WSS from "./util/scoketUrl";
export default {
  name: "App",
  data() {
    return {};
  },
  created() {},
  mounted() {
    console.log("APP")
    let tokens = this.$store.state.token.accessToken;
    this.$store.dispatch("setSocket", tokens);
    initWebSocket();
  },
  watch: {
  
  },

  methods: {},
};
</script>


<style>
@import "./assets/less/common.less";
#app {
  height: 100vh;
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/App.vue